import { routes } from "Projects/config/routes";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import PortfolioDetailsStep from "./routes/PortfolioDetailsStep";
import Evidences from "./routes/Evidences";
import StudentPortfolio from "./routes/StudentPortfolio";
import Feedback from "./routes/Feedback";
import FormalInterviews from "./routes/FormalInterviews";

const {
  portfolioDetails: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return withDynamicUrlValidation({
            component,
            urlValidationType: "number",
          });
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      Evidences(store),
      StudentPortfolio(store),
      Feedback(store),
      FormalInterviews(store),
      PortfolioDetailsStep(store),
    ],
  };
};
